// this is the algolia index that we are tuning by sending commerce events to
export const PERFORMER_RECOMMENDATION_INDEX = `${process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_INDEX_PREFIX}performers`
export const PRODUCTION_RECOMMENDATION_INDEX = `${process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_INDEX_PREFIX}productions`
export const VENUE_RECOMMENDATION_INDEX = `${process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_INDEX_PREFIX}venues`
